export default __webpack_public_path__ + "958cb45411dccc9a86076bb62fd33499.svg";